import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Utils from 'libs/Utils';
import PropTypes from 'prop-types';

import Header from 'components/Header';
import FormControl from 'components/FormControl';
import Button from 'components/Button';
import ToolTip from 'components/ToolTip';

import './styles.css';
import shapeShift from './img/shapeShift.svg';
import tooltip from './img/tooltip.svg';
import caret from './img/caret.svg';
import swap from './img/swap.svg';
import next from './img/next.svg';
import arrow from './img/arrow.svg';

class Amount extends Component {
  static renderAnnouncement(announcement, i) {
    return (<div className="announcement" key={i}>{announcement}</div>);
  }

  static renderExchange(exchange, i) {
    let fromIcon;
    switch (exchange.fromCoin.iconType) {
      case 'vector':
        fromIcon = (
          <img
            className="exchange__icon"
            src={exchange.fromCoin.iconUrl}
            alt={`${exchange.fromCoin.name} (${exchange.fromCoin.symbol}) icon`}
            width="20"
            height="20"
          />
        );
        break;
      case 'pixel':
        fromIcon = (
          <img
            className="exchange__icon"
            src={`${exchange.fromCoin.iconUrl}?size=40`}
            alt={`${exchange.fromCoin.name} (${exchange.fromCoin.symbol}) icon`}
            width="20"
            height="20"
          />
        );
        break;
      default:
        fromIcon = (
          <span className="exchange__icon exchange__icon--placeholder" />
        );
    }

    let toIcon;
    switch (exchange.toCoin.iconType) {
      case 'vector':
        toIcon = (
          <img
            className="exchange__icon"
            src={exchange.toCoin.iconUrl}
            alt={`${exchange.toCoin.name} (${exchange.toCoin.symbol}) icon`}
            width="20"
            height="20"
          />
        );
        break;
      case 'pixel':
        toIcon = (
          <img
            className="exchange__icon"
            src={`${exchange.toCoin.iconUrl}?size=40`}
            alt={`${exchange.toCoin.name} (${exchange.toCoin.symbol}) icon`}
            width="20"
            height="20"
          />
        );
        break;
      default:
        toIcon = (
          <span className="exchange__icon exchange__icon--placeholder" />
        );
    }

    return (
      <div className="exchange__item" key={i}>
        <div className="exchange__coin">
          {fromIcon}
          <div className="exchange__amount">{Utils.coinNumberFormat(exchange.fromAmount, '?')}</div>
          <div className="exchange__symbol">{exchange.fromCoin.symbol}</div>
        </div>
        <div className="exchange__arrow">
          <img className="exchange__img" src={arrow} alt="Exchanged to" width="8" height="13" />
        </div>
        <div className="exchange__coin">
          {toIcon}
          <div className="exchange__amount">{Utils.coinNumberFormat(exchange.toAmount, '?')}</div>
          <div className="exchange__symbol">{exchange.toCoin.symbol}</div>
        </div>
      </div>
    );
  }

  static renderSelect(to, coin) {
    let icon;
    switch (coin.iconType) {
      case 'vector':
        icon = (
          <img
            className="select__icon"
            src={coin.iconUrl}
            alt={`${coin.name} (${coin.symbol}) icon`}
            width="27"
            height="27"
          />
        );
        break;
      case 'pixel':
        icon = (
          <img
            className="select__icon"
            src={`${coin.iconUrl}?size=54`}
            alt={`${coin.name} (${coin.symbol}) icon`}
            width="27"
            height="27"
          />
        );
        break;
      default:
        icon = (
          <span className="select__icon select__icon--placeholder" />
        );
    }

    return (
      <Link className="amount__select" to={to}>
        {icon}
        <span className="select__symbol">{coin.symbol}</span>
        <img className="select__caret" src={caret} alt="Caret" width="13" height="8" />
      </Link>
    );
  }

  constructor(props) {
    super(props);

    this.setMax = this.setMax.bind(this);
    this.setFrom = this.setFrom.bind(this);
    this.setTo = this.setTo.bind(this);
    this.onFromChange = this.onFromChange.bind(this);
    this.onToChange = this.onToChange.bind(this);
    this.renderExchanges = this.renderExchanges.bind(this);

    this.state = {
      latestChange: 'from',
      fromAmount: '',
      toAmount: '',
    };
  }

  componentWillMount() {
    if (!this.props.recentExchangeStore.loaded) {
      this.props.recentExchangeStore.getExchanges((error) => {
        if (error) return console.log(error);
        return false;
      });
    }

    let amount = Utils.coinNumberFormat(this.props.infoStore.max, 2, 'floor', '.', '');
    if (this.state.fromAmount) amount = this.state.fromAmount;
    this.setFrom(amount);

    return false;
  }

  onFromChange(e) {
    if (e.target.value !== '' && !/^[0-9]+([.|,][0-9]*)?$/.test(e.target.value)) return;
    this.setFrom(e.target.value);
  }

  onToChange(e) {
    if (e.target.value !== '' && !/^[0-9]+([.|,][0-9]*)?$/.test(e.target.value)) return;
    this.setTo(e.target.value);
  }

  setMax() {
    this.setState({
      latestChange: 'from',
      fromAmount: this.props.infoStore.max,
      toAmount: Utils.roundDecimals(this.props.infoStore.max * this.props.infoStore.rate, 8),
    });
  }

  setFrom(amount) {
    const input = String(amount).replace(',', '.');
    const fromAmount = Utils.parseNumber(input);

    let toAmount = '';
    if (this.props.infoStore.rate > 0 && amount !== '') {
      toAmount = Utils.roundDecimals(fromAmount * this.props.infoStore.rate, 8);
    }
    this.setState({
      latestChange: 'from',
      fromAmount: input,
      toAmount,
    });
  }

  setTo(amount) {
    const input = String(amount).replace(',', '.');
    const toAmount = Utils.parseNumber(input);
    let fromAmount = '';
    if (this.props.infoStore.rate > 0 && amount !== '') {
      fromAmount = Utils.roundDecimals(toAmount / this.props.infoStore.rate, 8);
    }
    this.setState({
      latestChange: 'to',
      fromAmount,
      toAmount: input,
    });
  }

  renderExchanges() {
    if (!this.props.recentExchangeStore.loaded) return (<div className="exchanges__spinner" />);
    if (!this.props.recentExchangeStore.exchanges.length) return (<div className="exchanges__spinner" />);

    return this.props.recentExchangeStore.exchanges.map(Amount.renderExchange);
  }

  render() {
    const maxButton = (
      <button className="amount__max" onClick={this.setMax}>
        Max {this.props.infoStore.max}
      </button>
    );

    const sendTooltip = (
      <ToolTip text="Choose the coin and the amount you want to send.">
        <img className="amount__information" src={tooltip} width="15" height="15" alt="Tooltip" />
      </ToolTip>
    );

    const receiveTooltip = (
      <ToolTip text="Choose the coin and the amount you want to receive.">
        <img className="amount__information" src={tooltip} width="15" height="15" alt="Tooltip" />
      </ToolTip>
    );

    let amountIsTooHigh = false;
    if (Utils.parseNumber(this.state.fromAmount) > this.props.infoStore.max) amountIsTooHigh = true;

    let amountIsTooLow = false;
    if (Utils.parseNumber(this.state.fromAmount) < this.props.infoStore.min &&
        Utils.parseNumber(this.state.fromAmount) !== 0) {
      amountIsTooLow = true;
    }

    let amount = Utils.parseNumber(this.state.fromAmount);
    if (this.state.latestChange === 'to') amount = Utils.parseNumber(this.state.toAmount);

    return (
      <div className="amount">
        <Header light />
        <div className="amount__content">
          <h1 className="amount__title">
            The fastest<br />
            <span className="amount__emphasize">cryptocurrency exchange</span>
          </h1>
          <p className="amount__powered-by">Powered by <img className="amount__shapeshift" src={shapeShift} width="22" height="25" alt="ShapeShift" /> ShapeShift</p>

          {this.props.infoStore.announcements &&
          this.props.infoStore.announcements.map(Amount.renderAnnouncement)}

          <FormControl
            type="text"
            id="from"
            color={(amountIsTooHigh || amountIsTooLow) && this.state.latestChange === 'from' ? 'red' : null}
            pattern="^[0-9]+(\.[0-9]*)?$"
            value={`${this.state.fromAmount}`}
            placeholder="0.00"
            label="You send"
            tooltip={sendTooltip}
            labelButton={maxButton}
            onChange={this.onFromChange}
            append={Amount.renderSelect(`${this.props.match.url}/from`, this.props.infoStore.fromCoin)}
          />

          {amountIsTooHigh && this.state.latestChange === 'from' ?
            <div className="amount__error">
              {`Amount is too high, try a number below ${this.props.infoStore.max} ${this.props.infoStore.fromCoin.symbol}`}
            </div>
          : null}

          {amountIsTooLow && this.state.latestChange === 'from' ?
            <div className="amount__error">
              {`Amount is too low, try a number above ${this.props.infoStore.min} ${this.props.infoStore.fromCoin.symbol}`}
            </div>
          : null}

          <div className="swap">
            <Link className="swap__button" to={`/${this.props.infoStore.toCoin.symbol}_${this.props.infoStore.fromCoin.symbol}`}>
              <img className="swap__icon" src={swap} alt="Swap" width="25" height="16" />
            </Link>
          </div>

          <FormControl
            type="text"
            id="to"
            color={(amountIsTooHigh || amountIsTooLow) && this.state.latestChange === 'to' ? 'red' : null}
            pattern="^[0-9]+(\.[0-9]*)?$"
            value={`${this.state.toAmount}`}
            placeholder="0.00"
            label="You receive"
            tooltip={receiveTooltip}
            labelButton={<span className="amount__estimate">Estimate</span>}
            onChange={this.onToChange}
            append={Amount.renderSelect(`${this.props.match.url}/to`, this.props.infoStore.toCoin)}
          />

          {amountIsTooHigh && this.state.latestChange === 'to' ?
            <div className="amount__error">
              {`Amount is too high, try a number below ${Utils.roundDecimals(this.props.infoStore.max * this.props.infoStore.rate, 8)} ${this.props.infoStore.toCoin.symbol}`}
            </div>
          : null}

          {amountIsTooLow && this.state.latestChange === 'to' ?
            <div className="amount__error">
              {`Amount is too low, try a number above ${Utils.roundDecimals(this.props.infoStore.min * this.props.infoStore.rate, 8)} ${this.props.infoStore.toCoin.symbol}`}
            </div>
          : null}

          <div className="amount__button">
            {!amountIsTooHigh && !amountIsTooLow ?
              <Button
                color="green"
                full
                text="Next"
                imgRight={next}
                href={`/${this.props.infoStore.fromCoin.symbol}_${this.props.infoStore.toCoin.symbol}/addresses/${this.state.latestChange}/${amount}`}
              />
            :
              <Button
                type="button"
                color="green"
                full
                text="Next"
                imgRight={next}
                disabled
              />
            }
          </div>

          <p className="amount__advangages">Fast. Anonymous. 0.5% fee.</p>
          <p className="amount__average-exchange-time">Average exchange time is <span className="amount__exchange-time">{process.env.REACT_APP_EXCHANGE_TIME}</span> minutes</p>
        </div>
        <div className="amount__exchanges">
          <h2 className="exchanges__title">Latest exchanges</h2>
          <div className="exchanges__list">
            {this.renderExchanges()}
          </div>
        </div>
      </div>
    );
  }
}

Amount.propTypes = {
  infoStore: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  recentExchangeStore: PropTypes.object.isRequired,
};

export default Amount;



// WEBPACK FOOTER //
// ./src/scenes/Pair/scenes/Amount/index.jsx